import gqlApi from '../../api/gql'

// initial state
const state = () => ({
  members: [],
  membersUiMeta: [],
  member: {},
})

// getters
const getters = {}

// actions
const actions = {
  listMembers({ commit, state }, { searchTerm }) {
    return gqlApi.query({
      query: `
        query($name: String!, $searchTerm: String){
          GetUiMeta(name: $name, filterInvisible: true){
            key
            label
          }
          ListMembers(searchTerm: $searchTerm){
            cellphone
            created_date
            email
            full_name
            home_phone
            invisible_id
          }
        }
      `,
      variables: {
        name: 'MemberListVo',
        searchTerm: searchTerm,
      }
    }).then(data => {
      commit('set', ['membersUiMeta', data.GetUiMeta])
      commit('setMembers', data.ListMembers)
      return true
    })
  },

  getMember({ commit, state }, id) {
    return gqlApi.query({
      query: `
        query($id: String!){
          GetMember(id: $id){
            address
            birthday
            cellphone
            created_at
            email
            first_name
            full_name
            gender
            home_phone
            id
            last_name
            county
            district
            postal_code
            updated_at
          }
        }
      `,
      variables: {
        id: id,
      }
    }).then(data => {
      commit('setMember', data.GetMember)
      return true
    })
  },

  updateMember(_, member) {
    return gqlApi.query({
      query: `    
        mutation($input: MemberUpdateVo){
          UpdateMember(input: $input){
            id
          }
        }
      `,
      variables: {
        input: member,
      },
    }).then(() => {
      return true
    })
  },
}

// mutations
const mutations = {
  set (state, [variable, value]) {
    state[variable] = value
  },
  setMembers (state, members) {
    state.members = members
  },
  setMember (state, member) {
    state.member = member
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}